<div data-test-id="wrapper" class="flex flex-col justify-center w-full m-auto px-6 py-8 lg:py-11 md:max-w-[70%]">
  <span data-test-id="title" class="lg:text-2xl lg:leading-10 font-medium">Let’s confirm it’s you.</span>
  <span data-test-id="sub-title" class="mb-7 lg:mb-[53px] mt-2.5 leading-7 font-light"
    >We are committed to keeping your funds secure. Confirm you are the rightful owner of this account to proceed.</span
  >
  <img
    src="assets/images/National%20ID-UG.png"
    class="max-w-[300px] w-full h-auto self-center mb-9 lg:max-w-[380px]"
    alt="ID Card" />
  <span data-test-id="input-label" class="mb-5">Please enter your national identification number. (NIN)</span>

  <form action="#" [formGroup]="form" (ngSubmit)="handleSubmit()" class="w-full">
    <bey-input
      formControlName="id_number"
      class="mb-5 w-full"
      getElementId
      [control]="form.controls['id_number']"></bey-input>

    <bey-button
      [submit]="true"
      [disabled]="form.invalid"
      classList="w-full mt-4"
      placeholder="Next"
      getElementId
      getElementIdDescription="next"></bey-button>
  </form>
</div>
